import React from "react";
import { getApi } from '../../api/endpoints';
import ListingComponent from '../../components/ListingComponent';
import { useParams } from "react-router-dom"

const Index = () => {
    const defaultHeaderConfig = { disableSort: true };
    const params = useParams();

    const headers = [
        {
            ...defaultHeaderConfig,
            label: <div><span>Battery Transaction Id</span><br/><span>Battery Swap Id</span></div>,
            value: (row) => {
                if (row.user_id) {
                    return <div>
                        <span className="">{row.id}</span><br/>
                        <span className="">{row.battery_swap?.id}</span>
                    </div>
                }
            },
        },
        {
            ...defaultHeaderConfig,
            label: <div><span>User Id</span><br/><span>User Name</span><br/><span>User Rfid</span></div>,
            value: (row) => {
                if (row.user_id) {
                    return <div>
                        <span className="">{row.user_id}</span><br/>
                        <span className="">{row.user_name}</span><br/>
                        <span className="">{row.rfid}</span>
                    </div>
                }
            },
            disableSort: true
        },
        {
          ...defaultHeaderConfig,
          label: <div><span>Charging Station Id</span><br/><span>CS Serail No.</span></div>,
          value: (row) =>{
            return <div>
              {row.battery_swap?.charging_station_id || "-"} <br/>
              {row.battery_swap?.charging_station_serial_number || "-"}
            </div>
          }
        },
        {
            ...defaultHeaderConfig,
            label: <div><span>Battery Transaction Status</span><br/><span>Battery Swap Status</span></div>,
            value: (row) => {
                return <div>
                    <span className="">{row.status}</span><br/>
                    <span className="">{row.battery_swap?.status}</span>
                </div>
            },
            disableSort: true
        },
        {
          ...defaultHeaderConfig,
          label: 'IN Batteries',
          value: (row) =>{
            return <div>
              {row.battery_swap?.swap_batteries ? row.battery_swap?.swap_batteries.map((val, index) => <section key={index}><span>{val.old_battery}</span><br/></section>) : '-'}
            </div>
          }
        },
        {
          ...defaultHeaderConfig,
          label: 'OUT Batteries',
          value: (row) =>{
            return <div>
              {row.battery_swap?.swap_batteries ? row.battery_swap?.swap_batteries.map((val, index) => <section key={index}><span>{val.new_battery}</span><br/></section>) : '-'}
            </div>
          }
        },
        {
          ...defaultHeaderConfig,
          label: 'Swap Start Time',
          value: (row) =>{
            return <div>
              { row.battery_swap?.start_datetime }
            </div>
          }
        }
    ]

    return <div>
        <ListingComponent
          key={"PAGES.BatteryTransactionsListingPage.name"}
          breadcrumbs={[{ label: 'Home', url: '/dashboard' }, { label: 'Battery Transactions' }]}
          listingMutation={getApi('batteryTransactions')}
          className="battery-transactions-listing-page"
          contentHeading="Battery Transactions List - Results"
          headers={headers}
          recordsKey="battery_transactions"
          params={{
            user_id: params.id,
            fields: 'show'
          }}
          searchBy={['Battery Transaction ID', 'User ID']}
        />
    </div>
};

export default Index;
